<!--テストデータ選択ダイアログ-->
<!-- 固定データ確認 -->
<is-igx-mapping
    *ngIf="!loading"
    [environmentKey]="environmentKey"
    [mappingData]="mappingData"
    [leftWbsData]="StaticLeftWbsData"
    [rightWbsData]="StaticRightWbsData"
    [mappingDataHub]="mappingDataHub"
>
</is-igx-mapping>

<div *ngIf="selectedData">
    <h3>Selected Data:</h3>
    <pre>{{ selectedData | json }}</pre>
</div>
